import { post, get } from "../request";

// 退出
export function logout(data) {
  return post("/ProxyAdmin/v1/auth/logout", data);
}
// 账号密码登录
export function login(data) {
  return post("/ProxyAdmin/v1/auth/login", data);
}
// 账号验证码登录
export function loginByCode(data) {
  return post("/ProxyAdmin/v1/auth/quickLogin", data);
}
// 注册
export function register(data) {
  return post("/ProxyAdmin/v1/auth/register", data);
}
// 发送验证码
export function sendCode(data) {
  return post("/ProxyAdmin/v1/auth/sendCode", data);
}
// 获取用户信息
export function getInfo(data) {
  return get("/ProxyAdmin/v1/user", data);
}
// 微信二维码登录
export function wechatLogin(data) {
  return post("/ProxyAdmin/v1/auth/wechat/wxQrLogin", data);
}
// 检查状态
export function checkStatus(data) {
  return post("/ProxyAdmin/v1/auth/wechat/checkStatus", data);
}
// 检查验证码是否正确
export function checkVerifyCode(data) {
  return post("/ProxyAdmin/v1/auth/checkAccount", data);
}
// 获取国家和地区的区号
export function getAreaCodeList(data) {
  return get("/ProxyAdmin/v1/region/getList ", data);
}

// 获取用户所有权限
export function getUserPermissions() {
  return get("/ProxyAdmin/v1/user/menu");
}
